import company from '@/api/corporate/company-profile'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
    ...baseState
}

export const getters = {}

export const mutations = {
    ...baseMutations
}

export const actions = {
    fetch(context, attrubutes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attrubutes
        )
        return company.get({ params }).then(response => {
            context.commit('RECEIVE_RESOURCES', response)
            return Promise.resolve(response)
        })
    },
    store(context, data) {
        return company.store(data)
    },
    update(context, { id, data }) {
        return company.update(id, data)
    },
    destroy(context, id) {
        return company.destroy(id)
    },
    upload(context, data) {
        return company.imageLogo(data)
    }

}
